// @flow
import moment from 'moment';
import capitalize from 'lodash/capitalize';

import { SESSION_DISPLAY_STATUSES } from 'constants/session-statuses';

export const formatTime = (startTime: string, endTime: string): string =>
  `${moment(startTime).format('h:mm')} - ${moment(endTime).format('h:mm a')}`;

export const formatStatus = (status: string) => capitalize(SESSION_DISPLAY_STATUSES[status]);

export const isDeleteDisabled = (billCreatedAt: ?string, sessionCreatedAt: string) =>
  !!billCreatedAt && billCreatedAt > sessionCreatedAt;



// WEBPACK FOOTER //
// ./src/components/sessions/view/header/helpers.js